<template>
    <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div class="bg-white p-6 rounded-lg shadow-lg w-96">
            <h2 class="text-xl font-bold mb-4 text-center">作家中心认证</h2>
            
            <label class="warnTo block text-sm font-medium text-gray-700">严厉警告,你已进入平台监控范围:</label>
            <label class="warnTo block text-sm font-medium text-gray-700">"作家中心为个人工作区域! 不开放进入! 侵权必究!!"</label>
            <form v-if="account"  @submit.prevent="login">
                <!-- 账号输入框 -->
                <div class="mb-4">
                    <label class="block text-sm font-medium text-gray-700">账号：</label>
                    <input
                        type="text"
                        v-model.trim="form.user"
                        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secondary focus:ring-secondary"
                        :placeholder="请输入注册手机号/邮箱"
                        required
                    />
                </div>
                <!-- 密码输入框 -->
                <div class="mb-6">
                    <label class="block text-sm font-medium text-gray-700">密码：</label>
                    <input
                        type="password"
                        v-model.trim="form.password"
                        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-secondary focus:ring-secondary"
                        :placeholder="请输入密码"
                        required
                        minlength="6"
                    />
                </div>

                <!-- 登录按钮 -->
                <div class="flex space-x-4">
                    <button type="button" @click="$emit('close')" class="w-1/2 border border-gray-300 text-gray-700 py-2 rounded-md hover:bg-gray-50">
                        取消
                    </button>
                    <button type="submit" class="w-1/2 bg-secondary text-white py-2 rounded-md hover:bg-secondary-dark">
                        登录
                    </button>
                </div>
            </form>
            
        </div>
        

    </div>
</template>

<script setup>
import {onMounted, onUnmounted, ref, watch} from 'vue';
import { defineProps } from 'vue';
import axios from 'axios';
// const baseApiUrl = 'http://localhost:8081';
const baseApiUrl = ''; 
// 状态定义
// 定义 account prop
const props = defineProps({
    account: {
        type: Object,
        default: null
    }
});

const emit = defineEmits(['close', 'login-success']);
const form = ref({
    user: '',
    password: ''
});
const isFormValid = ref(false);
// 表单校验：账号非空、密码≥6位
const user = String(form.value.user).trim();
const password = form.value.password || '';
watch([() => form.value.user, () => form.value.password], () => {
    isFormValid.value = user.length > 0 && password.length >= 6;
});
// 登录处理函数
const handleLogin = () => {
    // 直接使用 form.value 进行验证
    const mockValidate = (user) => {
        return user.user === 'liang' && user.password === '123456';
    };

    if (mockValidate(form.value)) {
        
    } else {
        
    }
};
const login = async () => {
  try {
    const response = await axios.post(`${baseApiUrl}/api/novel/upload/writer-login`, form.value, {
      headers: { 'Content-Type': 'application/json' }
    })
    console.log(response.data);
    console.log(form.value);
    
    // 后端返回 { code:0, data:{ token, username, userId, role } }
    if (response.data.code === 0) {
      const { token, username, userId } = response.data.data;
      
      // 存储 JWT Token 和用户信息
      localStorage.setItem('writer-auth', token);
      localStorage.setItem('writer-username', username);
      localStorage.setItem('writer-userId', userId.toString());
      
      // 设置 Axios 默认 Authorization 头
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      
      emit('login-success');
      emit('close');
    } else {
      alert(response.data.msg || '账号或密码错误');
    }
  } catch (error) {
    console.error(error);
    alert('登录失败，请检查网络连接');
  }
};
</script>
<style>
/* 弹窗渐显渐隐动画 */
[v-cloak] {
    display: none;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
    opacity: 1;
}
.warnTo{
    color: red;
}
</style>